<template>
  <div>
    <el-dialog
      title="支付宝打款审核"
      width="600px"
      :append-to-body="true"
      :modal-append-to-body="false"
      v-on="$listeners"
      v-bind="$attrs"
      @close="onDialogClose"
      @open="onDialogOpen"
    >

      <div class="over">
        <el-table
          :data="dataSource"
          height="400"
          ref="$table"
          v-loading="loading"
          @selection-change="onSelectionChange"
        >
          <el-table-column
            label-class-name="selection-cell"
            type="selection"
            width="75"
            :selectable="canOperation"
          />
          <el-table-column label="申请信息" prop="apply_account" width="120px" />

          <el-table-column label="支付宝账号" prop="alipay_account" width="140px">
            <span slot-scope="{ row }">
              {{ row.alipay_account }}<br />{{ row.alipay_account_name }}
            </span>
          </el-table-column>

          <el-table-column label="金额（元）" prop="money" width="100px" />

          <el-table-column label="操作"  width="120px">
            <template slot-scope="{ row }">
              <zt-button
                width="80px"
                size="mini"
                :disabled="canNotOperation(row)"
                @click="onRefuse(row)"
              >{{ row.status | status2refuseBtnCN }}</zt-button>
            </template>
          </el-table-column>

        </el-table>

        <div class="pagenation">
          <span class="total-price">合计：￥{{this.totalPrice}}元</span>
          <zt-button
            type="primary"
            width="150px"
            :disabled="loading || selection.length === 0"
            @click="confirmVisible = true"
          >确认支付</zt-button>
        </div>
      </div>

    </el-dialog>

    <!-- 拒绝支付弹窗 -->
    <el-dialog
      title="确认拒绝支付？"
      :visible.sync="refuseVisible"
      width="400px"
      :append-to-body="true"
    >
      <span>用户账户余额已扣除，拒绝后须自行与用户协商支付哦~</span>
      <div class="reason"><el-input v-model="reject_reason" placeholder="请输入拒绝原因" /></div>
      <span slot="footer" class="dialog-footer">
        <zt-button
          width="100px"
          size="mini"
          type="primary"
          @click="onRefuseOne"
        >确定</zt-button>
        <zt-button
          width="100px"
          size="mini"
          @click="refuseVisible = false"
        >取消</zt-button>
      </span>
    </el-dialog>

    <!-- 确认支付弹窗 -->
    <el-dialog
      title="确认支付？"
      :visible.sync="confirmVisible"
      width="400px"
      :append-to-body="true"
    >
      <div>支付总金额：<span class="total-price">￥{{this.totalPrice}}元</span></div>
      <div style="margin-top:20px;">请确认账户余额充足，否则将支付失败哦~</div>
      <span slot="footer" class="dialog-footer">
        <zt-button
          width="100px"
          size="mini"
          type="primary"
          :loading="confirmLoading"
          @click="onPayment(selection)"
        >确定</zt-button>
        <zt-button
          width="100px"
          size="mini"
          :disabled="loading || confirmLoading"
          @click="confirmVisible = false"
        >取消</zt-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get_withdraw_list, reject_withdraw_info, fund_batch_create } from '@/api/pay.js'
import delay from '@/utils/delay'
import Vue from 'vue'

export default Vue.extend({
  filters: {
    // 拒绝按钮文案
    status2refuseBtnCN(status) {
      status = status.status ?? status
      return {
        0: '拒绝',
        1: '已申请',
        2: '已拒绝',
      }[status]
    },
  },

  data: () => ({
    dataSource: [],
    pagination: {
      page: 1, // 当前页
      pagesize: 200, // 每页大小
      pagecount: 1, // 总页数
      recordcount: 40, // 总条数
    },
    selection: [],

    loading: false,

    refuseVisible: false, //拒绝支付弹窗是否展示
    confirmVisible: false, //确认支付弹窗是否展示

    reject_reason: '', // 拒绝原因
    apply_id: null, // 拒绝id

    confirmLoading: false,
    refuseLoading: false,

    isMounted: false,
  }),

  computed: {
    totalPrice: (vm) => {
      let total = 0
      vm.selection.forEach(({ money }) => {
        total += Number(money)
      })
      return total.toFixed(2)
    },

    // 是否所有数据都不可以操作（只有 status=0才可以操作）
    isAllCantNotOperation: (vm) => {
      return vm.dataSource.find(vm.canOperation) === undefined
    },
  },

  methods: {

    // 打开
    async onDialogOpen() {
      await this.loadData()
      await this.$nextTick()
      if (!this.isAllCantNotOperation) {
        this.$refs.$table?.toggleAllSelection()
      }
    },

    // 关闭
    onDialogClose() {
      this.$emit('update:visible', false)
    },


    // 拒绝某个申请
    async onRefuseOne() {
      const { apply_id, reject_reason } = this

      const { data } = await reject_withdraw_info({ apply_id, reject_reason })
      if (!data.error_code) {
        // 更新本地数据
        const index = this.dataSource.findIndex(({ id }) => id === apply_id)
        const item = this.dataSource[index]
        this.$refs.$table?.toggleRowSelection(item, false)
        this.$set(this.dataSource[index], 'status', 2)

        this.$message.success('已拒绝')
        this.refuseVisible = false

      }else{
        this.$message.error(data.error_message);
      }
    },


    // 确认支付
    async onPayment(id) {
      id = id ?? this.selection
      if (Array.isArray(id)) {
        id = id.map((item) => isNaN(item) ? item.id : item).join(',')
      }
      if (!id) return

      this.confirmLoading = true
      const { data } = await fund_batch_create({ apply_ids: id })
      if(data.error_code === 0) {
        this.confirmVisible = false
        const a = document.createElement('a')
        a.target = '_blank'
        a.href = data.pay_url
        document.body.append(a)
        a.click()
        a.remove()
        this.$router.push('/finance/results')
      }else {
        this.$message.error(data.error_message)
      }
      this.confirmLoading = false
    },

    // 拒绝申请
    onRefuse(row) {
      this.refuseVisible = true
      this.apply_id = row.id
    },

    //表格选择
    onSelectionChange(selection) {
      // 只获取可以操作的项
      this.selection = selection.filter(this.canOperation)

      // 假的loading，需求要。。。
      this.loading = true
      this.closeLoading()
    },

    // 获取流水数据
    async loadData() {
      this.loading = true

      const { data } = await get_withdraw_list({ status: 0, pagesize: 200 })
      this.dataSource = data.list || []
      this.pagination.pagecount = data.pagecount || 0
      this.pagination.recordcount = data.recordcount || 0

      this.closeLoading()

      if (data.error_code !== 0) {
        this.$message.error(data.error_message)
      }
      await this.$nextTick()
    },

    // 表格页面改变
    onPageChange(page) {
      this.pagination.page = page
      this.loadData()
    },

    // 表格页面长度改变
    onSizeChange(pagesize) {
      this.pagination.pagesize = pagesize
      this.loadData()
    },

    // loading动画效果超过0.5s
    async closeLoading() {
      await delay(600)
      this.loading = false
    },

    // /**
    //  * 申请是否已被拒绝
    //  * @param { number | object }  status 状态或者行数据
    //  * @return { boolean }
    //  */
    // isRefused(status) {
    //   status = status.status ?? status
    //   return status === 2
    // },

    // /**
    //  * 申请是否未被拒绝
    //  * @param { number | object }  status 状态
    //  * @return { boolean }
    //  */
    // isNotRefuse(status) {
    //   return !this.isRefused(status)
    // },

    /**
     * 是否可以操作（拒绝、确认支付、选择）
     * @param { number | object }  status 状态
     * @return { boolean }
     */
    canOperation(status) {
      status = status.status ?? status
      return status === 0
    },

    /**
     * 是否不可以操作（拒绝、确认支付、选择）
     * @param { number | object }  status 状态
     * @return { boolean }
     */
    canNotOperation(status) {
      return !this.canOperation(status)
    },
  },
})
</script>

<style lang="scss" scoped>
.green {
  color: #3ac282;
}
.red {
  color: #fe4242;
}
.pagenation {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pagination {
  text-align: right;
}
.total-price {
  color:#ff0101;
  font-size: 16px;
  font-weight: 600;
}
.reason {
  margin-top:15px;
}
.dialog-footer {
  display:flex;
  .zt-button {
    margin-left:50px;
  }
}

.el-table /deep/ {
  table {
    width: 100% !important;
  }
  .selection-cell .cell:after {
    content: "选择";
    margin-left: 3px;
  }
}
</style>
